import { Modal } from "@2u-landing-pages/components/Modal";
import { ModalContent } from "@2u-landing-pages/components/Modal/ModalContent";
import { useModal } from "@2u-landing-pages/providers/ModalProvider";
import {
  TypeProgram_variationWithoutUnresolvableLinksResponse,
  TypeSchoolWithoutUnresolvableLinksResponse,
} from "@2u-landing-pages/types";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { IconFeatherX } from "@red-digital/bricks";
import React from "react";

const ModalWrapper: React.FC<{
  school: TypeSchoolWithoutUnresolvableLinksResponse;
  phoneNumber: string;
  programLogo: TypeProgram_variationWithoutUnresolvableLinksResponse["fields"]["logo_primary"];
  inspector: (props: { entryId: string; fieldId: string }) => any;
  isLoading: boolean;
}> = ({ school, phoneNumber, programLogo, inspector, isLoading }) => {
  const modalContext = useModal();
  const { isOpen, activeModal, closeModal } = modalContext || {};

  const updatedActiveModal = useContentfulLiveUpdates(activeModal || ({} as any));
  if (!activeModal || !closeModal) return null;
  if (isLoading || !isOpen) return null;
  if (!updatedActiveModal || !updatedActiveModal.fields) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      showCloseButton={true}
      customCloseButton={() => <IconFeatherX size="lg" />}
      debugOverride={updatedActiveModal.fields.debug_override}
    >
      <ModalContent
        modal={updatedActiveModal}
        school={school}
        phoneNumber={phoneNumber}
        programLogo={programLogo}
        inspector={inspector}
        isLoading={isLoading}
        mode="single-program"
      />
    </Modal>
  );
};

export default ModalWrapper;
